import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./footer.css";
class footer extends Component {
  render() {
    return (
      <div id="body">
        <Container>
          <span style={{ color: "grey" }}>123mkv Copyright © 2022</span>
        </Container>
      </div>
    );
  }
}

export default footer;
